import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SupportTicket, SupportTicketsService } from '../../core/services/support-tickets.service';
import { httpErrorMessage } from '../../core/utils/http-error-message';

@Component({ selector: 'app-support-tickets', imports: [FormsModule], templateUrl: './support-tickets.html', styleUrl: './support-tickets.scss' })
export class SupportTickets implements OnInit {
  private readonly service = inject(SupportTicketsService);
  tickets: SupportTicket[] = []; selected: SupportTicket | null = null;
  status = 'Open'; response = ''; loading = true; saving = false; error = ''; message = '';
  ngOnInit(): void { this.load(); }
  load(): void { this.loading = true; this.service.list().subscribe({
    next: tickets => { this.tickets = tickets; this.loading = false; },
    error: error => { this.error = httpErrorMessage(error, 'Unable to load support tickets.'); this.loading = false; }
  }); }
  open(ticket: SupportTicket): void { this.selected = ticket; this.status = ticket.status; this.response = ticket.adminResponse ?? ''; this.error = ''; this.message = ''; }
  save(): void { if (!this.selected) return; this.saving = true; this.service.update(this.selected.id, this.status, this.response).subscribe({
    next: ticket => { this.selected = ticket; this.saving = false; this.message = 'Ticket updated.'; this.load(); },
    error: error => { this.saving = false; this.error = httpErrorMessage(error, 'Unable to update ticket.'); }
  }); }
}
